// removed by extract-text-webpack-plugin
module.exports = {"xrColorPrimary":"#2362FB"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/common.scss
// module id = ksBL
// module chunks = 184